export const anyOf = (predicates, tooltipMessage) => ({
  anyOf: predicates,
  tooltipMessage
});
export function maxDuration(maxMs, tooltipMessage) {
  const predicate = {
    field: 'duration',
    op: 'LTE',
    value: maxMs
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}
export function minDuration(minMs, tooltipMessage) {
  const predicate = {
    field: 'duration',
    op: 'GTE',
    value: minMs
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}
export function requireVideoType(type, tooltipMessage) {
  const predicate = {
    field: 'videoType',
    op: 'EQ',
    value: type
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}
export function requireVideoOrigin(origin, tooltipMessage) {
  const predicate = {
    field: 'videoOrigin',
    op: 'EQ',
    value: origin
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}
export function requirePublicVideo(tooltipMessage) {
  const predicate = {
    field: 'sourceFileAllowsAnonymousAccess',
    op: 'EQ',
    value: true
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}
export function requireAnyoneWithLinkVideo(tooltipMessage) {
  const predicate = {
    field: 'visibility',
    op: 'EQ',
    value: 'ANYONE_WITH_LINK'
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}
export function minWidth(minPx, tooltipMessage) {
  const predicate = {
    field: 'width',
    op: 'GTE',
    value: minPx
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}
export function maxWidth(maxPx, tooltipMessage) {
  const predicate = {
    field: 'width',
    op: 'LTE',
    value: maxPx
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}
export function minHeight(minPx, tooltipMessage) {
  const predicate = {
    field: 'height',
    op: 'GTE',
    value: minPx
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}
export function maxHeight(maxPx, tooltipMessage) {
  const predicate = {
    field: 'height',
    op: 'LTE',
    value: maxPx
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}
export function requireFileExtension(extension, tooltipMessage) {
  const normalizedExtension = extension.toLowerCase().replace(/^\./, '');
  const predicate = {
    field: 'fileExtension',
    op: 'EQ',
    value: normalizedExtension
  };
  return tooltipMessage !== undefined ? {
    predicate,
    tooltipMessage
  } : predicate;
}